import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
export function CartButton() {
  const {
    totalItems,
    openCart
  } = useCart();
  return <button onClick={openCart} className="relative p-2 hover:bg-gray-800 rounded-lg transition-colors" aria-label={`Open cart with ${totalItems} items`} data-id="element-17">
      <ShoppingCart className="w-5 h-5 text-white" data-id="element-18" />
      {totalItems > 0 && <span className="absolute -top-1 -right-1 bg-brand-red text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-id="element-19">
          {totalItems}
        </span>}
    </button>;
}